import React, { SVGProps } from 'react';

const GreenTriangle = (props: SVGProps<SVGSVGElement>) => (
	<svg width='10' height='6' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M5 0L9.33013 5.25H0.669873L5 0Z' fill='#019448' />
	</svg>
);

export default GreenTriangle;
